import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import * as settings from "../../../../shared/lib/api-constant";
import { StorageService } from './../../../../shared/service';
import { switchMap } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { CacheService } from 'src/app/core/cache/cache.service';
import { CACHEABLE_ENDPOINTS, CachePolicy } from 'src/app/core/cache/cache.config';

@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {

  constructor(public storageService: StorageService, 
              private cacheService: CacheService, 
              public router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/login') {
          // Cancel all api calls on logout
          this.cacheService.clearAll();
          this.cacheService.clearPersistentCache();
        }
      }
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.storageService.getItem('token');

    // Add base URL and headers if the URL is not absolute
    if (!/^(http|https):/i.test(request.url)) {
      const url = environment.baseurl + request.url;
      const headers: any = {
        'Authorization': token ? `Bearer ${token}` : '',
        'Cache-Control': 'no-cache'
      };

      if (!(request.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }

      request = request.clone({ url, headers: new HttpHeaders(headers) });
    }

    const shortUrl = request.url.replace(environment.baseurl, '');
    const cachePolicy: CachePolicy | undefined = this.cacheService.getCachePolicy(shortUrl);

    const forceRefresh = request.params.has('forceRefresh') || request.headers.has('x-force-refresh');

    // If the URL is in the cacheable list and forceRefresh isn't set, check the cache
    if (cachePolicy && !forceRefresh) {
      // console.log(`[cache] Checking cache for ${shortUrl}`);
      
      // Asynchronously check cache in localStorage or IndexedDB
      return from(this.cacheService.get(shortUrl)).pipe(
        switchMap((cachedData: any) => {
          if (cachedData) {
            // If cache is found, return it immediately as an HTTP response
            return of(new HttpResponse({ body: cachedData.data, status: 200 }));
          }

          // Attach cache policy for response interceptor to handle caching
          request = request.clone({
            headers: request.headers.set('x-cache-policy', JSON.stringify(cachePolicy))
          });

          // Proceed with the HTTP request
          return next.handle(request);
        })
      );
    }

    // Proceed with the HTTP request if no caching policy or forceRefresh is set
    // Remove the forceRefresh header from the request before sending to backend
    request = request.clone({
      headers: request.headers.delete('x-force-refresh')
    });

    return next.handle(request);
  }
}
